// extracted by mini-css-extract-plugin
export default {"preloader":"preloader_preloader__2nZCy","preloader__img":"preloader_preloader__img__HJhT-","l4":"preloader_l4__mq27w"};